import { PDFDownloadLink, Document, Page, View, Text, StyleSheet, Image } from "@react-pdf/renderer"
import { useEffect, useRef } from "react";
import { Competition } from "../Widgets/Competition";

const documentStyles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        width: '100%',
        fontWeight: 100,
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        gap: 30,
        margin: 20,
        padding: 20,
        fontSize: 12,
        fontWeight: 100,
    },
    heading: {
        fontSize: 20,
    },
    article: {
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        paddingTop: 7,
        paddingLeft: 7
    },
    headline: {
        fontWeight: '900',
        textDecoration: 'underline'
    },
    subheading: {
        fontSize: 15,
        paddingTop: 7
    }
});

export const DashboardDocument = ({ metaInformation, forms, statements }) => {
    useEffect(() => {
        console.log(forms.trends);
    }, []);

    const UserDocument = (src) => (
        <Document>
            <Page
                size="A4"
                orientation="portrait"
                style={documentStyles.page}
            >
                <View style={documentStyles.section}>
                    <View>
                        <Text style={documentStyles.heading}>
                            User Information
                        </Text>
                        <View style={documentStyles.article}>
                            <Text>
                                <Text style={documentStyles.headline}>Name:</Text>
                                &nbsp;
                                {metaInformation.name}
                            </Text>
                            <Text>
                                <Text style={documentStyles.headline}>Surname:</Text>
                                &nbsp;
                                {metaInformation.surname}
                            </Text>
                            <Text>
                                <Text style={documentStyles.headline}>Email:</Text>
                                &nbsp;
                                {metaInformation.email}
                            </Text>
                            <Text>
                                <Text style={documentStyles.headline}>Website:</Text>
                                &nbsp;
                                {metaInformation.website}
                            </Text>
                        </View>
                    </View>
                    <View>
                        <Text style={documentStyles.heading}>
                            Answers
                        </Text>
                        <View>
                            <Text style={documentStyles.subheading}>
                                Intro
                            </Text>
                            <View style={documentStyles.article}>
                                <Text>
                                    <Text style={documentStyles.headline}>Company Name:</Text>
                                    &nbsp;
                                    {forms.intro.companyName}
                                </Text>
                                <Text>
                                    <Text style={documentStyles.headline}>Problem Statement:</Text>
                                    &nbsp;
                                    {forms.intro.problemStatement}
                                </Text>
                                <Text>
                                    <Text style={documentStyles.headline}>Problem Solution:</Text>
                                    &nbsp;
                                    {forms.intro.problemSolution}
                                </Text>
                            </View>
                        </View>
                        <View>
                            <Text style={documentStyles.subheading}>
                                Purpose
                            </Text>
                            <View style={documentStyles.article}>
                                <Text style={documentStyles.subheading}>
                                    Passion
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>Things That Made You Proud:</Text>
                                        &nbsp;
                                        {forms.passion.thingsThatMadeYouProud.map((el, index) => (
                                            el.proud.replace(/\\r/g, '')
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Emerged From Cases:</Text>
                                        &nbsp;
                                        {forms.passion.emergedFromCases}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Emerged From Sentence:</Text>
                                        &nbsp;
                                        {forms.passion.emergedFromSentence}
                                    </Text>
                                </View>
                                <Text style={documentStyles.subheading}>
                                    People
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>The People You Were Helping:</Text>
                                        &nbsp;
                                        {forms.people.people1.map((el, index) => (
                                            "\n" + el.people
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>The People You Will Target:</Text>
                                        &nbsp;
                                        {forms.people.people2.map((el, index) => (
                                            "\n" + el.target
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Combine:</Text>
                                        &nbsp;
                                        {forms.people.combine}
                                    </Text>
                                </View>
                                <Text style={documentStyles.subheading}>
                                    Impact
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>The Benefit People Got From You:</Text>
                                        &nbsp;
                                        {forms.impact.impactBenefit1.map((el, index) => (
                                            "\n" + el.impactBenefit
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>The New Benefits:</Text>
                                        &nbsp;
                                        {forms.impact.impactBenefit2.map((el, index) => (
                                            "\n" + el.impactBenefit
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Combine:</Text>
                                        &nbsp;
                                        {forms.impact.combine}
                                    </Text>
                                </View>
                                <Text style={documentStyles.subheading}>
                                    Product
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>Products/Services:</Text>
                                        &nbsp;
                                        {forms.product.productService1.map((el, index) => (
                                            "\n" + el.productService
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Combine:</Text>
                                        &nbsp;
                                        {forms.product.combine}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View>
                            <Text style={documentStyles.subheading}>
                                Vision
                            </Text>
                            <View style={documentStyles.article}>
                                <Text>
                                    <Text style={documentStyles.headline}>Company Potential:</Text>
                                    &nbsp;
                                    {forms.vision.companyPotential.map((el, index) => (
                                        el.companyPotential
                                    ))}
                                </Text>
                                <Text>
                                    <Text style={documentStyles.headline}>World Potential:</Text>
                                    &nbsp;
                                    {forms.vision.worldPotential}
                                </Text>
                            </View>
                        </View>
                        <View>
                            <Text style={documentStyles.subheading}>
                                Personality
                            </Text>
                            <View style={documentStyles.article}>
                                <Text style={documentStyles.subheading}>
                                    Values
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>Core Personality Values:</Text>
                                        &nbsp;
                                        {forms.values.personalityValues.map((el, index) => (
                                            "\n" + el.personalityValue
                                        ))}
                                    </Text>
                                </View>
                                <Text style={documentStyles.subheading}>
                                    Look
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>All Look and Feel Attributes:</Text>
                                        &nbsp;
                                        {forms.look.allLookAndFeelAttributes.map((el, index) => (
                                            "\n" + el.lookAndFeelAttribute
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Five Look and Feel Attributes:</Text>
                                        &nbsp;
                                        {forms.look.fiveLookAndFeelAttributes.map((el, index) => (
                                            "\n" + el.lookAndFeelAttribute
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Three Look and Feel Attributes:</Text>
                                        &nbsp;
                                        {forms.look.threeLookAndFeelAttributes.map((el, index) => (
                                            "\n" + el.lookAndFeelAttribute
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Companies That Look Like That:</Text>
                                        &nbsp;
                                        {forms.look.companiesThatLookLikeThat1.map((el, index) => (
                                            "\n" + el.companyThatLookLikeThat
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>People That Look Like That:</Text>
                                        &nbsp;
                                        {forms.look.companiesThatLookLikeThat2.map((el, index) => (
                                            "\n" + el.companyThatLookLikeThat
                                        ))}
                                    </Text>
                                </View>
                                <Text style={documentStyles.subheading}>
                                    Tone
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>All Tone Attributes:</Text>
                                        &nbsp;
                                        {forms.tone.allToneAttributes.map((el, index) => (
                                            "\n" + el.toneAttribute
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Five Tone Attributes:</Text>
                                        &nbsp;
                                        {forms.tone.fiveToneAttributes.map((el, index) => (
                                            "\n" + el.toneAttribute
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Three Tone Attributes:</Text>
                                        &nbsp;
                                        {forms.tone.threeToneAttributes.map((el, index) => (
                                            "\n" + el.toneAttribute
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>Companies That Look Like That:</Text>
                                        &nbsp;
                                        {forms.tone.companiesThatSoundLikeThat.map((el, index) => (
                                            "\n" + el.companyThatSoundsLikeThat
                                        ))}
                                    </Text>
                                    <Text>
                                        <Text style={documentStyles.headline}>People That Look Like That:</Text>
                                        &nbsp;
                                        {forms.tone.peopleThatSoundLikeThat.map((el, index) => (
                                            "\n" + el.peopleThatSoundLikeThat
                                        ))}
                                    </Text>
                                </View>
                                <Text style={documentStyles.subheading}>
                                    Attributes
                                </Text>
                                <View style={documentStyles.article}>
                                    <View style={{ display: 'flex', gap: 2 }}>
                                        {forms.attributes.personalityAttributes.map((el, index) => (
                                            <View style={{ display: 'flex', gap: 2 }}>
                                                <Text>
                                                    {el.leftAttribute}
                                                </Text>
                                                <Text>
                                                    {el.personalityAttribute}
                                                </Text>
                                                <Text>
                                                    {el.rightAttribute}
                                                </Text>
                                            </View>
                                        ))}
                                    </View>
                                </View>
                            </View>
                        </View>
                        <View>
                            <Text style={documentStyles.subheading}>
                                Relationships
                            </Text>
                            <View style={documentStyles.article}>
                                <Text style={documentStyles.subheading}>
                                    Competition
                                </Text>
                                <View style={documentStyles.article}>
                                    <Image src={src} />
                                </View>
                                <Text style={documentStyles.subheading}>
                                    Trends
                                </Text>
                                <View style={documentStyles.article}>
                                    <Text>
                                        <Text style={documentStyles.headline}>Trends:</Text>
                                        &nbsp;
                                        {forms.trends.trends.map((el, index) => (
                                            "\n" + el.trend
                                        ))}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View>
                        <Text style={documentStyles.heading}>
                            Statements
                        </Text>
                        <View >
                            <Text>Purpose:{statements.purpose}</Text>
                            <Text>Vision: {statements.vision}</Text>
                            <Text>Positioning: {statements.positioning}</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document >
    )
    return (
        <PDFDownloadLink
            document={<UserDocument />}
            fileName="name.pdf"
        >
            <span>Export as PDF</span>
        </PDFDownloadLink>
    )
}